module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Giorgio Agamben, Adam Kotsko\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Giorgio Agamben")]), _vm._v(" is a contemporary Italian philosopher and political theorist whose works have been translated into numerous languages. His most recent title with Stanford University Press is "), _c('I', [_vm._v("The Omnibus \"Homo Sacer\"")]), _vm._v(" (2017).")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QVSCpb/tc-custom/9781503605831.jpg?1705206819658",
      "alt": "This image is the cover for the book Karman, Meridian: Crossing Aesthetics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Karman, Meridian: Crossing Aesthetics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The renowned Italian philosopher offers a penetrating analysis of judgment, guilt, free will, and society in this brief yet profoundly original treatise.")]), _c('br'), _c('br'), _vm._v("What does it mean to be responsible for our actions? In this brief and elegant study, Giorgio Agamben traces our most profound moral intuitions back to their roots in the sphere of law and punishment. Moral accountability, human free agency, and even the very concept of cause and effect all find their origin in the language of the trial, which Western philosophy and theology both transform into the paradigm for all of human life. "), _c('br'), _c('br'), _vm._v("In his search for a way out of this destructive paradigm, Agamben not only draws on minority opinions within the Western tradition but engages at length with Buddhist texts and concepts for the first time. In sum, "), _c('i', [_vm._v("Karman")]), _vm._v(" deepens and rearticulates some of Agamben’s core insights while breaking significant new ground.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Stanford University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0